import type { ListSort } from "./pagination.models";
import { sortSchema } from "./pagination.models";

/**
 * Columns the super-admin billing-record list can be ordered by.
 *
 * The list is capped rather than paginated, so the ordering decides *which*
 * records you see, not just their arrangement — which is exactly why it has to be
 * resolved in the query. A client-side sort would rank the fetched rows while the
 * true extremes stayed outside the cap.
 */
export const BILLING_RECORD_SORT_KEYS = [
  "createdAt",
  "cost",
  "serviceType",
] as const;

export const billingRecordSortSchema = sortSchema(BILLING_RECORD_SORT_KEYS);

export type BillingRecordSortKey = (typeof BILLING_RECORD_SORT_KEYS)[number];
export type BillingRecordSort = ListSort<BillingRecordSortKey>;

/** Newest-first, which is the ordering the list has always applied. */
export const DEFAULT_BILLING_RECORD_SORT: BillingRecordSort = {
  key: "createdAt",
  direction: "desc",
};
